import GitLabLogo from '../logos/tools/GitLab.svg'
import JenkinsLogo from '../logos/tools/Jenkins.svg'
import ArgoCDLogo from '../logos/tools/ArgoCD.svg'
import AnsibleLogo from '../logos/tools/Ansible.svg'
import TerraformLogo from '../logos/tools/Terraform.svg'
import PRTGLogo from '../logos/tools/PRTG.svg'
import PrometheusLogo from '../logos/tools/Prometheus.svg'
import GrafanaLogo from '../logos/tools/Grafana.svg'
import ZabbixLogo from '../logos/tools/Zabbix.svg'
import SentryLogo from '../logos/tools/Sentry.svg'
import SplunkLogo from '../logos/tools/Splunk.svg'
import ELKStackLogo from '../logos/tools/ELK Stack.svg'
import SysLogLogo from '../logos/tools/SysLog.svg'
import DataDogLogo from '../logos/tools/DataDog.svg'
import LogglyLogo from '../logos/tools/Loggly.svg'
import MySQLLogo from '../logos/tools/MySQL.svg'
import MariaDBLogo from '../logos/tools/MariaDB.svg'
import MongoDBLogo from '../logos/tools/MongoDB.svg'
import PostgreSQLLogo from '../logos/tools/PostgreSQL.svg'
import SQLServerLogo from '../logos/tools/SQL Server.svg'
import OracleLogo from '../logos/tools/Oracle.svg'
import RedisLogo from '../logos/tools/Redis.svg'
import CouchDBLogo from '../logos/tools/CouchDB.svg'
import CockRoachDBLogo from '../logos/tools/CockRoachDB.svg'
import NginxLogo from '../logos/tools/Nginx.svg'
import ApacheLogo from '../logos/tools/Apache.svg'
import IISLogo from '../logos/tools/IIS.svg'
import OpenStackLogo from '../logos/tools/Open Stack.svg'
import CephLogo from '../logos/tools/Ceph.svg'
import KubernetesLogo from '../logos/tools/Kubernetes.svg'
import DockerLogo from '../logos/tools/Docker.svg'
import DockerSwarmLogo from '../logos/tools/Docker Swarm.svg'
import PortainerLogo from '../logos/tools/Portainer.svg'
import RancherLogo from '../logos/tools/Rancher.svg'
import RabbitMQLogo from '../logos/tools/RabbitMQ.svg'
import ApacheKafkaLogo from '../logos/tools/Apache Kafka.svg'
import ApacheSparkLogo from '../logos/tools/Apache Spark.svg'
import OpenEBSLogo from '../logos/tools/OpenEBS.svg'
import GlusterFSLogo from '../logos/tools/GlusterFS.svg'
import LongHornLogo from '../logos/tools/LongHorn.svg'
import ApacheJMeterLogo from '../logos/tools/Apache JMeter.svg'
import BigBlueButtonLogo from '../logos/tools/BigBlueButton.svg'
import AdobeConnectLogo from '../logos/tools/Adobe Connect.svg'

export const devopsCategories = [
  {
    id: 'cat-1',
    translationKey: 'category1',
    tools: [
      { name: 'GitLab', logo: GitLabLogo },
      { name: 'Jenkins', logo: JenkinsLogo },
      { name: 'ArgoCD', logo: ArgoCDLogo },
      { name: 'Ansible', logo: AnsibleLogo },
      { name: 'Terraform', logo: TerraformLogo }
    ]
  },
  {
    id: 'cat-2',
    translationKey: 'category2',
    tools: [
      { name: 'PRTG', logo: PRTGLogo },
      { name: 'Prometheus', logo: PrometheusLogo },
      { name: 'Grafana', logo: GrafanaLogo },
      { name: 'Zabbix', logo: ZabbixLogo },
      { name: 'Sentry', logo: SentryLogo },
      { name: 'Splunk', logo: SplunkLogo },
      { name: 'ELK Stack', logo: ELKStackLogo },
      { name: 'SysLog', logo: SysLogLogo },
      { name: 'DataDog', logo: DataDogLogo },
      { name: 'Loggly', logo: LogglyLogo }
    ]
  },
  {
    id: 'cat-3',
    translationKey: 'category3',
    tools: [
      { name: 'MySQL', logo: MySQLLogo },
      { name: 'MariaDB', logo: MariaDBLogo },
      { name: 'MongoDB', logo: MongoDBLogo },
      { name: 'PostgreSQL', logo: PostgreSQLLogo },
      { name: 'SQL Server', logo: SQLServerLogo },
      { name: 'Oracle', logo: OracleLogo },
      { name: 'Redis', logo: RedisLogo },
      { name: 'CouchDB', logo: CouchDBLogo },
      { name: 'CockRoachDB', logo: CockRoachDBLogo }
    ]
  },
  {
    id: 'cat-4',
    translationKey: 'category4',
    tools: [
      { name: 'Nginx', logo: NginxLogo },
      { name: 'Apache', logo: ApacheLogo },
      { name: 'IIS', logo: IISLogo }
    ]
  },
  {
    id: 'cat-5',
    translationKey: 'category5',
    tools: [
      { name: 'Open Stack', logo: OpenStackLogo },
      { name: 'Ceph', logo: CephLogo },
      { name: 'Kubernetes', logo: KubernetesLogo },
      { name: 'Docker', logo: DockerLogo },
      { name: 'Docker Swarm', logo: DockerSwarmLogo },
      { name: 'Portainer', logo: PortainerLogo },
      { name: 'Rancher', logo: RancherLogo }
    ]
  },
  {
    id: 'cat-6',
    translationKey: 'category6',
    tools: [
      { name: 'RabbitMQ', logo: RabbitMQLogo },
      { name: 'Apache Kafka', logo: ApacheKafkaLogo },
      { name: 'Apache Spark', logo: ApacheSparkLogo }
    ]
  },
  {
    id: 'cat-7',
    translationKey: 'category7',
    tools: [
      { name: 'OpenEBS', logo: OpenEBSLogo },
      { name: 'GlusterFS', logo: GlusterFSLogo },
      { name: 'LongHorn', logo: LongHornLogo }
    ]
  },
  {
    id: 'cat-8',
    translationKey: 'category8',
    tools: [
      { name: 'Apache JMeter', logo: ApacheJMeterLogo }
    ]
  },
  {
    id: 'cat-9',
    translationKey: 'category9',
    tools: [
      { name: 'BigBlueButton', logo: BigBlueButtonLogo },
      { name: 'Adobe Connect', logo: AdobeConnectLogo }
    ]
  }
]
